module.exports = __webpack_public_path__ + "static/media/attLogo.32034291.png";